

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { PaymentVoucherSetup } from "../../components/PaymentVoucherSetup/PaymentVoucherSetup";


export const PaymentVoucherSetupPage = () => {
    return (
        <AuthenticatedLayout
            pageTitle="Payment Voucher Setup"
            pageTitleIcon={<DescriptionOutlinedIcon />}
            breadcrumbCurrentPageName=""
            mainContents={<PaymentVoucherSetup />}
        />
    );
};
